import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { formatApiError } from '../lib/api';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Loader2, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

const LOGO = '/logo.png';

export default function LoginPage() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try { const d = await login(email, password); toast.success(`Bienvenido, ${d.name}`); nav(d.role === 'admin' ? '/admin' : '/dashboard'); }
    catch (e) { setError(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div data-testid="login-page" className="min-h-[80vh] flex items-center justify-center px-4 bg-[#F4F5F7]">
      <div className="w-full max-w-sm animate-fade-in">
        <div className="bg-white border-2 border-[#0B1F40] p-8 brutal-shadow">
          <div className="flex flex-col items-center mb-8">
            <img src={LOGO} alt="RP" className="h-16 w-16 mb-4 border-2 border-[#0B1F40]" />
            <h1 className="text-xl text-[#0B1F40] tracking-tighter" style={{ fontFamily: 'Archivo Black' }}>INICIAR SESIÓN</h1>
          </div>
          {error && <div data-testid="login-error" className="mb-4 p-3 bg-red-50 border-l-4 border-[#E50B15] text-[#E50B15] text-xs font-bold">{error}</div>}
          <form onSubmit={submit} className="space-y-4">
            <div>
              <Label className="text-[10px] font-black tracking-[0.15em] uppercase text-[#0B1F40]/50">EMAIL</Label>
              <Input data-testid="login-email" type="email" value={email} onChange={e => setEmail(e.target.value)}
                className="rounded-none border-2 border-[#0B1F40]/20 focus:border-[#E50B15] focus:ring-0 mt-1 h-11 font-bold" placeholder="tu@email.com" required />
            </div>
            <div>
              <Label className="text-[10px] font-black tracking-[0.15em] uppercase text-[#0B1F40]/50">CONTRASEÑA</Label>
              <div className="relative mt-1">
                <Input data-testid="login-password" type={showPwd ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)}
                  className="rounded-none border-2 border-[#0B1F40]/20 focus:border-[#E50B15] focus:ring-0 h-11 font-bold pr-11" placeholder="Contraseña" required />
                <button type="button" data-testid="toggle-password-login" onClick={() => setShowPwd(!showPwd)}
                  className="absolute right-0 top-0 h-11 w-11 flex items-center justify-center text-[#0B1F40]/40 hover:text-[#E50B15] transition-colors">
                  {showPwd ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </button>
              </div>
            </div>
            <button data-testid="login-submit" type="submit" disabled={loading}
              className="w-full bg-[#E50B15] text-white font-black text-sm h-11 brutal-btn-press transition-all flex items-center justify-center gap-2" style={{ boxShadow: '4px 4px 0px #0B1F40' }}>
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} ENTRAR
            </button>
          </form>
          <p className="mt-4 text-center">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-xs font-bold text-[#0B1F40]/40 hover:text-[#E50B15]">¿Olvidaste tu contraseña?</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
